import { format, parse } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export const getFormattedDate = ({ date: _date = '', time: _time = '' }: { date?: string; time?: string }): string => {
    const time = _time || format(new Date(), 'HH:mm')
    const date = _date || format(new Date(), 'dd/MM/yyyy')

    const parsedDate = parse(`${date} ${time}`, 'dd/MM/yyyy HH:mm', new Date())
    return formatInTimeZone(parsedDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ss'Z'")
}

export const parseDate = (date: string): { date: string; time: string } => ({
    date: format(date, 'dd/MM/yyyy'),
    time: format(date, 'HH:mm'),
})
